import React from "react";
import InsightFilterHelper, {
  FILTER_AGE_GROUP,
  FILTER_COUNTRY,
  FILTER_DAY,
  FILTER_FROM_DATE,
  FILTER_GENDER,
  FILTER_HOUR,
  FILTER_INTEREST,
  FILTER_INTEREST_OPTION,
  FILTER_LOCALITY,
  FILTER_MONTH,
  FILTER_NATIONALITY, FILTER_REGION, FILTER_SHOWCASE,
  FILTER_SUB_LOCALITY,
  FILTER_TO_DATE,
  FILTER_TYPE_DROP_DOWN,
  FILTER_TYPE_RADIO,
  FILTER_WEEK_DAY
} from "src/js/components/insight/InsightFilterHelper";
import {DAYS, GENDERS, GENDERS_WITH_NR, HOURS, MONTHS, SHOWCASE, WEEK_DAYS} from "src/js/constants/ApiConstants";
import AutoCompleteView from "src/js/components/commons/AutoCompleteView";
import View from "src/js/components/commons/View";
import {ColorTitle, ColorWhite} from "src/styles/Colors";
import AppText from "src/js/components/commons/AppText";
import {FontWeightMedium} from "src/res/FontWeight";
import {Button} from "@material-ui/core";
import {ImageIcon} from "src/js/components/commons/ViewHelper";
import {FormattedMessage} from "react-intl";
import PropTypes from "prop-types";
import {fetchActivityQuestionsDropDown} from "src/js/actions/activitiesActions";
import {
  fetchCountries,
  fetchLocalities,
  fetchNationalities,
  fetchRegions,
  fetchSubLocalities
} from "src/js/actions/locationAction";
import {fetchAgeGroup} from "src/js/actions/insightsActions";
import {connect} from "react-redux";
import {
  baseStyles,
  BORDER_RADIUS,
  FIELD_SPACE,
  FIELD_SPACE_XS,
  withMediaQueries,
  withMultipleStyles
} from "src/styles/Styles";
import {getArrayOfIds} from "src/js/utils/utils";
import Space from "src/js/components/commons/Space";
import FieldSpace from "src/js/components/commons/FieldSpace";
import SectionHeaderView from "src/js/components/commons/SectionHeaderView";
import MomentUtils from "@date-io/moment";
import {KeyboardDatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import {cloneDeep} from "lodash";
import ScrollView from "src/js/components/commons/ScrollView";
import constants from "src/js/constants";
import {logDebug} from "src/js/utils/AppLog";

const useStyles = (theme) => ({
  mainContainerWrapper: {
    width: '100%',
    height: '100%',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('xs')]: {
      // alignItems: 'flex-end',
      justifyContent: 'flex-end',
      paddingTop: 64,
    }
  },
  mainContainer: {
    width: '100%',
    maxWidth: Math.min(window.appWidth, 920),
    backgroundColor: ColorWhite,
    borderRadius: BORDER_RADIUS,
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    padding: FIELD_SPACE,
    paddingBottom: 0,
    [theme.breakpoints.down('xs')]: {
      height: '100%',
      borderRadius: 0,
      borderTopLeftRadius: BORDER_RADIUS,
      borderTopRightRadius: BORDER_RADIUS,
      padding: FIELD_SPACE_XS,
      paddingBottom: 0,
    }
  }
})

class InsightFilterScreen extends React.Component {

  constructor(props) {
    super(props);
    this.filters = this.props.filters;
    this.appliedFilters = this.props.appliedFilters;
    if (!this.appliedFilters) {
        this.appliedFilters = {};
    }

    this.timeoutHandlers = {};
    this.state = {};
  }

  componentDidMount() {
    this.processOptions();
    const {fetchAgeGroup, fetchNationalities, fetchActivityQuestionsDropDown, fetchCountries} = this.props;
    fetchAgeGroup();
    fetchNationalities();
    fetchActivityQuestionsDropDown();
    fetchCountries();
  }

  componentWillUnmount() {
    Object.keys(this.timeoutHandlers).forEach((key) => {
      clearTimeout(this.timeoutHandlers[key]);
      delete this.timeoutHandlers[key];
    })
  }

  resetFilters = () => {
    this.appliedFilters = {};
  };

  processOptions = () => {
    this.genders = [];
    GENDERS_WITH_NR.forEach((item) => {
      const newItem = cloneDeep(item);
      newItem.name = this.context.intl.formatMessage({id: newItem.nameId});
      this.genders.push(newItem);
    });

    this.showcase = [];
    SHOWCASE.forEach((item) => {
      const newItem = cloneDeep(item);
      newItem.name = this.context.intl.formatMessage({id: newItem.nameId});
      this.showcase.push(newItem);
    });

    this.months = [];
    MONTHS.forEach((item) => {
      const newItem = cloneDeep(item);
      newItem.name = this.context.intl.formatMessage({id: newItem.nameId});
      this.months.push(newItem);
    });

    this.weekDays = [];
    WEEK_DAYS.forEach((item) => {
      const newItem = cloneDeep(item);
      newItem.name = this.context.intl.formatMessage({id: newItem.nameId});
      this.weekDays.push(newItem);
    });
  }

  render() {
    const {isXS, app, classes} = this.props;
    const filtersLength = this.filters ? this.filters.length : 0;
    const indexSplit = isXS ? filtersLength : 2;

    return (
      <div className={classes.mainContainerWrapper}>
        <div className={classes.mainContainer}>
          <div style={{width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
            <AppText
              variant={'h6'}
              style={{
                color: ColorTitle,
                fontWeight: FontWeightMedium,
                textAlign: 'center'}}>
              <FormattedMessage id={'activity.filters'}/>
            </AppText>
            <div style={{flex: 1}}/>
            <Space vertical={8} />
            <Button
              disableElevation
              variant={'outlined'}
              color={'secondary'}
              onClick={this.onResetClicked}>
              <FormattedMessage id={'activity.resetFilters'}/></Button>
            <Space vertical={isXS ? 8 : 12} />
            <Button
              disableElevation
              variant={'contained'}
              color={'primary'}
              onClick={this.onDoneClicked}>
              <FormattedMessage id={'activity.applyFilters'}/></Button>
          </div>
          <FieldSpace multiplier={1} />
          <ScrollView>
            <div className={classes.viewColumnFullWidthNoCenter}>
              <FieldSpace multiplier={1} />
              <div className={classes.viewRowFullWidthNoCenter}>
                <div className={classes.flexColumnNoCenter}>
                  <div className={classes.formActivity}>
                    <div>
                      {this.filters && this.filters.map((item, index) => {
                        if (index >= indexSplit) {
                          return null;
                        }
                        return (
                          <div className={classes.viewColumnFullWidthNoCenter}>
                            {index > 0 ? <FieldSpace multiplier={1.5} /> : null}
                            {this.getFilterGroupView(item)}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
                {indexSplit < filtersLength ?
                  <div className={classes.flexColumnNoCenter} style={{marginLeft: app.isLTR ? 2 * FIELD_SPACE : 0, marginRight: !app.isLTR ? 2 * FIELD_SPACE : 0, alignItems: 'flex-end'}}>
                    <div className={classes.formActivity} style={{width: '100%'}}>
                      <div>
                        {this.filters && this.filters.map((item, index) => {
                          if (index < indexSplit) {
                            return null;
                          }
                          return (
                            <div className={classes.viewColumnFullWidthNoCenter}>
                              {index-indexSplit > 0 ? <FieldSpace multiplier={1.5} /> : null}
                              {this.getFilterGroupView(item)}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                  : null
                }
              </div>
              <FieldSpace multiplier={0.75} />
            </div>
          </ScrollView>
        </div>
      </div>
    );
  }

  getFilterGroupView(filterGroup) {
    const {classes} = this.props;
    let filterViews = null;
    const filters = filterGroup.items;
    if (filters && filters.length > 0) {
      filterViews = [];
      for (let i = 0; i < filters.length; i++) {
        const filter = filters[i];
        if (filter.id === FILTER_FROM_DATE) {
          const filterA = filters[i + 1];
          if (filterA.id === FILTER_TO_DATE) {
            filterViews.push(this.getDoubleDateView(filter, filterA));
            i++;
            continue;
          }
        }
        if (filter.id === FILTER_MONTH) {
          const filterA = filters[i + 1];
          if (filterA.id === FILTER_WEEK_DAY) {
            filterViews.push(this.getDoubleDropDownView(filter, filterA));
            i++;
            continue;
          }
        }
        if (filter.id === FILTER_DAY) {
          const filterA = filters[i + 1];
          if (filterA.id === FILTER_HOUR) {
            filterViews.push(this.getDoubleDropDownView(filter, filterA));
            i++;
            continue;
          }
        }
        filterViews.push(this.getFilterView(filter));
      }
    }
    return (
      <View className={classes.viewColumnFullWidthNoCenter}>
        <SectionHeaderView label={filterGroup.name} />
        {filterViews}
      </View>
    );
  }

  getFilterView(filter) {
      if (InsightFilterHelper.getType(filter.id) === FILTER_TYPE_RADIO) {
          return this.getRadioView(filter);
      }
      if (InsightFilterHelper.getType(filter.id) === FILTER_TYPE_DROP_DOWN) {
          return this.getDropDownView(filter);
      }
      return null;
  }

  getDoubleDateView(filter1, filter2) {
    const maxDate1 = this.appliedFilters[filter2.id] && this.appliedFilters[filter2.id].length > 0 ? this.appliedFilters[filter2.id][0] : undefined;
    const minDate2 = this.appliedFilters[filter1.id] && this.appliedFilters[filter1.id].length > 0 ? this.appliedFilters[filter1.id][0] : undefined;
    return (
      <View style={{flexDirection: 'row'}}>
        <View style={{flex: 1}}>{this.getDateView(filter1, undefined, maxDate1)}</View>
        <FieldSpace multiplier={0.75} vertical={true}/>
        <View style={{flex: 1}}>{this.getDateView(filter2, minDate2, undefined)}</View>
      </View>
    );
  }

  getDateView(filter, minDate, maxDate) {
    let value = null;
    if (this.appliedFilters[filter.id] && this.appliedFilters[filter.id].length > 0) {
        value = this.appliedFilters[filter.id][0];
    }
    return (
      <View className={this.props.classes.viewColumnFullWidthNoCenter}>
        <MuiPickersUtilsProvider utils={MomentUtils} locale={'en'}>
          <KeyboardDatePicker
            inputVariant="filled"
            variant="inline"
            size="small"
            fullWidth
            autoOk
            disableFuture
            InputProps={{disableUnderline: true}}
            format="DD/MM/yyyy"
            minDate={minDate}
            maxDate={maxDate}
            id={'date'+ filter.id}
            name={'date'+ filter.id}
            invalidDateMessage={<FormattedMessage id='generic.invalidDateFormat'/>}
            maxDateMessage={<FormattedMessage id='generic.invalidDate'/>}
            minDateMessage={<FormattedMessage id='generic.invalidDate'/>}
            label={filter.name}
            value={value}
            onChange={(date) => {
              if (date && date.isValid()) {
                this.appliedFilters[filter.id] = [date];
              } else {
                delete this.appliedFilters[filter.id];
              }
              this.setState({reload: !this.state.reload})
            }}
            keyboardbuttonprops={{
              'aria-label': 'change date',
            }}
          />
          <FieldSpace multiplier={0.75} />
        </MuiPickersUtilsProvider>
      </View>
    );
  }

  getDoubleDropDownView(filter1, filter2) {
    return (
      <View style={{flexDirection: 'row'}}>
        <View style={{flex: 1}}>{this.getDropDownView(filter1)}</View>
        <FieldSpace multiplier={0.75} vertical={true}/>
        <View style={{flex: 1}}>{this.getDropDownView(filter2)}</View>
      </View>
    );
  }

  getRadioView(filter) {
    const {classes, app, isXS} = this.props;
    let options = null;
    if (filter.id === FILTER_GENDER) {
      options = GENDERS;
    } else if (filter.id === FILTER_SHOWCASE) {
      options = SHOWCASE;
    }
    const selectedValues = this.appliedFilters[filter.id];
    const selectedValue = selectedValues && selectedValues.length > 0 ? selectedValues[0].id : 0;

    return (
      <React.Fragment>
        <div className={classes.viewRowFullWidth} key={filter.id}>
          {options && options.map((item, index) => {
            const isSelected = item.id === selectedValue;
            return (
              <React.Fragment>
                <Button
                  color={isSelected ? 'primary' : 'secondary'}
                  variant={"outlined"}
                  size={isXS ? 'medium' : 'large'}
                  onClick={() => {
                    this.appliedFilters[filter.id] = [item];
                    this.setState({reload: !this.state.reload});
                  }}
                  style={isXS ? {} : {minHeight: 50, maxHeight: 50}}
                  className={isSelected ? classes.selectedColorButton : classes.whiteSecondaryColorButton}
                  startIcon={isSelected ? <ImageIcon src={require('src/images/ic_checked.png')} /> : null}>
                  <FormattedMessage id={item.name} />
                </Button>
                <FieldSpace multiplier={0.75} vertical={true}/>
              </React.Fragment>
            );
          })}
        </div>
        <FieldSpace multiplier={0.75}/>
      </React.Fragment>
    );
  }

  endpointCallback = (filterId) => {
    this.setState({['isLoading-'+ filterId]: false});
  };

  getDropDownView(filter) {
    const {classes, activities} = this.props;
    const filterId = filter.id;
    let fetchData = null;
    if (filterId === FILTER_LOCALITY || filterId === FILTER_SUB_LOCALITY || filterId === FILTER_REGION) {
      fetchData = (search) => {
        const countries = this.appliedFilters[FILTER_COUNTRY];
        let countryIds = null;
        if (countries && countries.length > 0) {
          countryIds = getArrayOfIds(countries);
        }

        if (filterId === FILTER_REGION) {
          this.props.fetchRegions(search, countryIds).then(this.endpointCallback.bind(this, filterId)).catch(this.endpointCallback.bind(this, filterId));
        } else if (filterId === FILTER_SUB_LOCALITY) {
          this.props.fetchSubLocalities(search, countryIds).then(this.endpointCallback.bind(this, filterId)).catch(this.endpointCallback.bind(this, filterId));
        } else {
          this.props.fetchLocalities(search, countryIds).then(this.endpointCallback.bind(this, filterId)).catch(this.endpointCallback.bind(this, filterId));
        }
      };
    }

    let placeholderId = fetchData ? 'activity.manage.placeholderTargetingSelectSearch' : 'activity.manage.placeholderTargetingSelect';
    let multipleLimit = 20;
    let options = null;
    let hasSubOptions = false;
    let selectedSubValues = null;
    let lengthToSearch = 2;
    let searchTextLength = 1000;
    let disabled = false;
    let hidden = false;
    if (filterId === FILTER_GENDER) {
      multipleLimit = 1;
      options = this.genders;
    } else if (filterId === FILTER_SHOWCASE) {
      multipleLimit = 1;
      options = this.showcase;
    } else if (filterId === FILTER_MONTH) {
      options = this.months;
    } else if (filterId === FILTER_WEEK_DAY) {
      options = this.weekDays;
    } else if (filterId === FILTER_DAY) {
      options = DAYS;
    } else if (filterId === FILTER_HOUR) {
      options = HOURS;
    } else if (filterId === FILTER_COUNTRY) {
      multipleLimit = 4;
      options = activities.countries;
    } else if (filterId === FILTER_REGION) {
      multipleLimit = 10;
      disabled = !this.appliedFilters[FILTER_COUNTRY] || this.appliedFilters[FILTER_COUNTRY].length === 0;
      options = activities.regions;
    } else if (filterId === FILTER_LOCALITY) {
      multipleLimit = 10;
      disabled = !this.appliedFilters[FILTER_COUNTRY] || this.appliedFilters[FILTER_COUNTRY].length === 0;
      options = activities.localities;
    } else if (filterId === FILTER_SUB_LOCALITY) {
      multipleLimit = 10;
      disabled = !this.appliedFilters[FILTER_COUNTRY] || this.appliedFilters[FILTER_COUNTRY].length === 0;
      options = activities.subLocalities;
      hidden = true;
      if (this.appliedFilters[FILTER_COUNTRY] && this.appliedFilters[FILTER_COUNTRY].length > 0) {
        this.appliedFilters[FILTER_COUNTRY].forEach((countryL) => {
          if (countryL.id === 1188) {
            hidden = false;
          }
        });
      }
    } else if (filterId === FILTER_AGE_GROUP) {
      options = activities.ageGroups;
    } else if (filterId === FILTER_NATIONALITY) {
      options = activities.nationalities;
    } else if (filterId === FILTER_INTEREST) {
      multipleLimit = 4;
      options = activities.questionsNOptions;
      hasSubOptions = true;
      selectedSubValues = this.appliedFilters[FILTER_INTEREST_OPTION] || [];
    }

    const selectedValues = this.appliedFilters[filterId];
    let selectedValue = null;
    if (selectedValues && selectedValues.length > 0) {
      selectedValue = selectedValues[0];
    }

    let values = null;
    let inputValue = null;
    if (multipleLimit > 1) {
      values = selectedValues;
      inputValue = this.state['search-'+ filterId];
    } else {
      values = selectedValue;
      inputValue = selectedValue ? selectedValue.name : '';
    }

    if (hidden) {
      return null;
    }

    return (
      <GetDropDownView
        filterId={filterId}
        classes={classes}
        disabled={disabled}
        hasSubOptions={hasSubOptions}
        multipleLimit={multipleLimit}
        label={filter.name}
        placeholderId={placeholderId}
        loading={this.state['isLoading-'+ filterId]}
        searchTextLength={searchTextLength}
        options={options}
        values={values}
        selectedSubValues={selectedSubValues}
        intl={this.context.intl}
        inputValue={inputValue}
        onInputChange={(value) => {
          if (fetchData && value.length >= lengthToSearch) {
            this.setState({['search-'+ filterId]: value, ['isLoading-'+ filterId]: true}, () => {
              if (this.timeoutHandlers[filterId]) {
                clearTimeout(this.timeoutHandlers[filterId]);
                delete this.timeoutHandlers[filterId];
              }
              this.timeoutHandlers[filterId] = setTimeout(() => {
                fetchData(value);
              }, 300);
            });
          } else {
            this.setState({['search-'+ filterId]: value, ['isLoading-'+ filterId]: false}, () => {
              if (this.timeoutHandlers[filterId]) {
                clearTimeout(this.timeoutHandlers[filterId]);
                delete this.timeoutHandlers[filterId];
              }
            });
          }
        }}
        onSelect={(value, subValue) => {
          let newValues = null;
          if (multipleLimit > 1) {
            newValues = value;
          } else {
            newValues = value ? [value] : null;
          }
          if (newValues && newValues.length > 0) {
            this.appliedFilters[filterId] = newValues;
          } else {
            delete this.appliedFilters[filterId];
          }

          if (filterId === FILTER_COUNTRY) {
            if (!newValues || newValues.length === 0) {
              delete this.appliedFilters[FILTER_REGION];
              delete this.appliedFilters[FILTER_LOCALITY];
              delete this.appliedFilters[FILTER_SUB_LOCALITY];
            }
          }
          if (filterId === FILTER_INTEREST) {
            if (subValue && subValue.length > 0) {
              this.appliedFilters[FILTER_INTEREST_OPTION] = subValue;
            } else {
              delete this.appliedFilters[FILTER_INTEREST_OPTION];
            }
          }
          this.setState({['search-'+ filterId]: ''});
        }}
      />
    );
  }

  onResetClicked = () => {
    this.appliedFilters = {};
    if (this.props.onResult) {
      this.props.onResult(this.appliedFilters);
    }
  };

  onDoneClicked = () => {
    if (this.props.onResult) {
      this.props.onResult(this.appliedFilters);
    }
  };
}

InsightFilterScreen.propTypes = {
  classes: PropTypes.object,
  app: PropTypes.object,
  filters: PropTypes.object,
  appliedFilters: PropTypes.object,
  onResult: PropTypes.func.isRequired,
};

InsightFilterScreen.contextTypes = {
  intl:PropTypes.object.isRequired
}

function mapStateToProps(state) {
  const props = {
    app: state.app,
    activities: state.admin.activities,
  };
  return props;
  // return {
  //   app: state.app,
  //   activities: state.admin.activities,
  // };
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchNationalities: (search) => dispatch(fetchNationalities(search)),
    fetchCountries: (search) => dispatch(fetchCountries(search)),
    fetchLocalities: (search, countryIds) => dispatch(fetchLocalities(search, countryIds)),
    fetchSubLocalities: (search, countryIds) => dispatch(fetchSubLocalities(search, countryIds)),
    fetchRegions: (search, countryIds) => dispatch(fetchRegions(search, countryIds)),
    fetchActivityQuestionsDropDown: (search) => dispatch(fetchActivityQuestionsDropDown(search, 1, 100, true)),
    fetchAgeGroup: () => dispatch(fetchAgeGroup()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withMultipleStyles(baseStyles, useStyles)(withMediaQueries([
    ['isDrawerHidden', theme => theme.breakpoints.down('sm'), {defaultMatches: true}],
    ['isXS', theme => theme.breakpoints.down('xs'), {defaultMatches: true}],
    ['isMD', theme => theme.breakpoints.down('md'), {defaultMatches: true}]
  ])(InsightFilterScreen))
);

const GetDropDownView = React.memo((props) => {
  const {filterId, classes, disabled, hasSubOptions, multipleLimit, label,
    placeholderId, loading, searchTextLength, options, values, selectedSubValues,
    inputValue, onInputChange, onSelect, intl} = props;

  return (
    <div key={filterId} className={classes.container}>
      <AutoCompleteView
        fullWidth
        disabled={disabled}
        hasSubOptions={hasSubOptions}
        multiple={multipleLimit > 1}
        multipleLimit={multipleLimit}
        key={''+ filterId}
        // filterOptions={FilterOptionsAny}
        label={label}
        placeholder={intl.formatMessage({id: placeholderId})}
        loading={loading}
        searchTextLength={searchTextLength}
        options={options}
        selectedValues={values}
        selectedSubValues={selectedSubValues}
        inputValue={inputValue}
        onInputChange={onInputChange}
        onSelect={onSelect}
      />
      <FieldSpace multiplier={0.75}/>
    </div>
  )
});
